import styles from '../controls.module.scss'

export function EmptyPropertiesState() {
  return (
    <div className={styles.emptyState}>Select an element to view properties</div>
  )
}
